module.exports = function () {

    if ($('.topic-landing').length === 0) {
        return;
    }
        
    $('.topic-landing__show-more-description-toggle').click(function () {                
        $(this).addClass('topic-landing__show-more-description-toggle--hidden');

        var $container = $(this).closest('.topic-landing__title-container');
        if ($container.length) {           
            var $showMoreDescription = $container.find('.topic-landing__show-more-description');

            if ($showMoreDescription.length) {
                $showMoreDescription.removeClass('topic-landing__show-more-description--hidden');
            }
        }
        return false;
    });

    $('.topic-landing__show-less-description-toggle').click(function () {
        var $showMoreDescription = $(this).closest('.topic-landing__show-more-description');
        if ($showMoreDescription.length) {
            $showMoreDescription.addClass('topic-landing__show-more-description--hidden');
        }
        var $container = $(this).closest('.topic-landing__title-container');
        if ($container.length) {
            var $showMoreToggle = $container.find('.topic-landing__show-more-description-toggle');
            if ($showMoreToggle.length) {
                $showMoreToggle.removeClass('topic-landing__show-more-description-toggle--hidden');
            }
        }
        return false;
    });
};